let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1imTS")).then(() => parcelRequire('8lQN4'));